<template>
  <div class="navbar-wrap">
    <div class="navbar-main">
      <div class="left">
        <el-button type="text" class="collapse-btn" @click="toggleSidebar">
          <i :class="sidebarOpened ? 'el-icon-s-fold' : 'el-icon-s-unfold'"></i>
        </el-button>

        <el-breadcrumb separator="/">
          <el-breadcrumb-item v-for="item in breadcrumbItems" :key="item.path || item.name">
            <span class="crumb">{{ item.title }}</span>
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="actions">
        <el-tag type="success" size="mini">{{ roleNamesText }}</el-tag>
        <span class="username">{{ userName }}</span>
        <el-button type="text" @click="handleLogout">退出登录</el-button>
      </div>
    </div>

    <div class="tags-bar">
      <div
        v-for="view in visitedViews"
        :key="view.path"
        class="tag-item"
        :class="{ active: isActive(view) }"
        @click="goToView(view)"
      >
        <span class="tag-title">{{ view.title }}</span>
        <i
          v-if="!isDashboard(view)"
          class="el-icon-close tag-close"
          @click.stop="closeView(view)"
        ></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    sidebarOpened() {
      return this.$store.state.app.sidebarOpened
    },
    userName() {
      return this.$store.state.user.name
    },
    roleNamesText() {
      const role = this.$store.state.user.role
      return role ? role.name : '未分配角色'
    },
    visitedViews() {
      return this.$store.state.tagsView.visitedViews
    },
    breadcrumbItems() {
      return this.$route.matched
        .filter(item => item.meta && item.meta.title)
        .map(item => ({
          path: item.path,
          name: item.name,
          title: item.meta.title
        }))
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        if (route && route.meta && route.meta.title) {
          this.$store.dispatch('tagsView/addView', route)
        }
      }
    }
  },
  methods: {
    toggleSidebar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    async handleLogout() {
      await this.$store.dispatch('user/logout')
      this.$store.dispatch('tagsView/clearViews')
      this.$router.push('/login')
    },
    isActive(view) {
      return view.path === this.$route.path
    },
    isDashboard(view) {
      return view.path === '/dashboard'
    },
    goToView(view) {
      if (view.path !== this.$route.path) {
        this.$router.push(view.path)
      }
    },
    async closeView(view) {
      await this.$store.dispatch('tagsView/delView', view)
      if (this.isActive(view)) {
        const latestView = this.visitedViews[this.visitedViews.length - 1]
        this.$router.push((latestView && latestView.path) || '/dashboard')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar-wrap {
  background: #fff;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.06);
  position: sticky;
  top: 0;
  z-index: 1000;
  flex-shrink: 0;
}

.navbar-main {
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 18px;
  border-bottom: 1px solid #eef2f7;
}

.left {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.collapse-btn {
  font-size: 18px;
  color: #1f2937;
  padding: 6px;
}

.crumb {
  color: #334155;
  font-weight: 500;
}

.actions {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

.username {
  color: #606266;
}

.tags-bar {
  height: 40px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 18px;
  overflow-x: auto;
  white-space: nowrap;
  background: #fff;
}

.tag-item {
  height: 26px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 0 10px;
  border: 1px solid #dce3ed;
  border-radius: 4px;
  background: #f8fafc;
  color: #4b5563;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.tag-item.active {
  background: #3b82f6;
  border-color: #3b82f6;
  color: #fff;
}

.tag-title {
  line-height: 1;
  font-size: 12px;
}

.tag-close {
  font-size: 10px;
}
</style>
